export enum HlaLocusGroup {
    A       = 1,
    B       = 2,
    C       = 3,
    Drb1    = 4,
    Drb345  = 5,
    Dqa1    = 8,
    Dqb1    = 9,
    Dpa1    = 10,
    Dpb1    = 11
}